export default function submitOAuthForm(action) {
  const csrfToken = document.head.querySelector('[name=csrf-token]')?.content;
  const form = document.createElement('form');

  form.method = 'POST';
  form.action = action;
  form.style.display = 'none';

  if (csrfToken) {
    const tokenInput = document.createElement('input');

    tokenInput.type = 'hidden';
    tokenInput.name = 'authenticity_token';
    tokenInput.value = csrfToken;

    form.appendChild(tokenInput);
  }

  document.body.appendChild(form);
  form.submit();
}
